const events = [
  {
    id: 1,
    date: "MARZEC 2026",
    city: "Warszawa",
    title: "Spain Tourism Workshop 2026",
    description: "Całodniowe spotkanie B2B z prezentacjami partnerów z Wysp Kanaryjskich. Bezpośrednie kontakty z hotelami, touroperatorami i liniami lotniczymi.",
    type: "Workshop",
    spots: "Ograniczona liczba miejsc",
    icon: "ri-building-line",
  },
  {
    id: 2,
    date: "KWIECIEŃ 2026",
    city: "La Gomera, Hiszpania",
    title: "FAM Trip — Hotel Jardín Tecina",
    description: "Ekskluzywna wizyta studyjna dla wybranych agentów. Poznaj resort od środka i zbuduj relacje z lokalnym teamem sprzedażowym.",
    type: "FAM Trip",
    spots: "12 miejsc",
    icon: "ri-flight-takeoff-line",
  },
  {
    id: 3,
    date: "CZERWIEC 2026",
    city: "Kraków",
    title: "Meet Hiszpania Networking Evening",
    description: "Spotkanie networkingowe dla agencji i partnerów. Nowe oferty, wino i relacje w nieformalnej atmosferze.",
    type: "Networking",
    spots: "Otwarte rejestracje",
    icon: "ri-goblet-line",
  },
  {
    id: 4,
    date: "PAŹDZIERNIK 2026",
    city: "Fuerteventura, Hiszpania",
    title: "FAM Trip — Playitas Resort",
    description: "Wizyta studyjna do Playitas Resort — dla agencji specjalizujących się w turystyce aktywnej, sportowej i incentive.",
    type: "FAM Trip",
    spots: "10 miejsc",
    icon: "ri-flight-takeoff-line",
  },
];

const typeBadge: Record<string, string> = {
  Workshop: "bg-red-600 text-white",
  "FAM Trip": "bg-green-700 text-white",
  Networking: "text-white",
};

export default function MHEvents() {
  return (
    <section id="events" className="bg-white py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-16">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <div className="h-1 w-10 rounded-full" style={{ backgroundColor: "#CC1F1A" }} />
              <span className="text-sm font-bold uppercase tracking-widest text-gray-400">Kalendarz wydarzeń</span>
            </div>
            <h2 className="text-4xl lg:text-5xl font-extrabold text-gray-900 leading-tight uppercase">
              B2B Polonia
              <br />
              <span style={{ color: "#CC1F1A" }}>2026</span>
            </h2>
          </div>
          <p className="text-gray-500 max-w-sm leading-relaxed">
            Warsztaty, wizyty studyjne i networking — buduj relacje i poznaj Hiszpanię z pierwszej ręki.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-5">
          {events.map((event, idx) => (
            <div
              key={event.id}
              className="flex gap-5 p-6 rounded-xl border border-gray-100 hover:border-red-200 bg-white hover:bg-red-50/30 transition-all group"
            >
              <div
                className="w-14 h-14 rounded-xl flex items-center justify-center shrink-0 text-white text-2xl"
                style={{ backgroundColor: idx % 2 === 0 ? "#CC1F1A" : "#1a1a1a" }}
              >
                <i className={event.icon} />
              </div>
              <div className="flex-1">
                <div className="flex flex-wrap items-center gap-2 mb-2">
                  <span
                    className={`text-xs font-bold px-2.5 py-1 rounded-full uppercase tracking-wide ${
                      event.type === "Networking"
                        ? "text-white"
                        : typeBadge[event.type]
                    }`}
                    style={event.type === "Networking" ? { backgroundColor: "#6B5A4A" } : {}}
                  >
                    {event.type}
                  </span>
                  <span className="text-xs text-gray-400 font-medium uppercase tracking-wide">
                    <i className="ri-map-pin-line mr-1" />{event.city}
                  </span>
                </div>
                <p className="text-xs font-extrabold uppercase tracking-widest mb-1" style={{ color: "#CC1F1A" }}>
                  {event.date}
                </p>
                <h3 className="text-lg font-bold text-gray-900 mb-2 leading-snug">{event.title}</h3>
                <p className="text-sm text-gray-500 leading-relaxed mb-3">{event.description}</p>
                <div className="flex items-center justify-between pt-3 border-t border-gray-100">
                  <span className="text-xs text-gray-400 font-medium">
                    <i className="ri-group-line mr-1" />{event.spots}
                  </span>
                  <button
                    onClick={() => document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" })}
                    className="text-xs font-bold uppercase tracking-widest cursor-pointer whitespace-nowrap hover:underline"
                    style={{ color: "#CC1F1A" }}
                  >
                    Zapytaj o udział →
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
